import React from "react";

import classNames from "classnames";

import { MetaFieldType } from "src/app/methods/getMetaFieldTypeOptions";
import { GlobalTaskMetaField } from "../GlobalTaskDetails/components/GlobalTaskMetaField/GlobalTaskMetaField";
import { MetaFieldOptions } from "src/app/Task/Subtask/Subtask";

import "./CreatorTags.scss";

export type CreatorTags = {
  data: MetaFieldOptions;
  name: string;
  uuid: string;
  type: MetaFieldType;
  value: null | string[];
  valueSource: null | string;
};

export enum CreatorTagsContext {
  CreatorSearch = "creator-search",
  CreatorCRM = "creator-crm",
}

interface Props {
  creatorTags: null | CreatorTags;
  taskId: string;
  context: CreatorTagsContext;
}

export const CreatorTags = ({ creatorTags, taskId, context }: Props) => {
  if (!creatorTags?.data?.singleSelectOptions?.length) return null;

  return (
    <div className={classNames("creator-tags", `creator-tags--${context}`)}>
      <GlobalTaskMetaField
        field={creatorTags}
        taskId={taskId}
        key={creatorTags.uuid}
      />
    </div>
  );
};
